import {useEffect, useRef} from "react";
import {css} from "@emotion/react";

const WIDGETS_SCRIPT_ID = "x-widgets-script";
const WIDGETS_SCRIPT_SRC = "https://platform.twitter.com/widgets.js";

let widgetsLoadPromise: Promise<void> | null = null;

function loadXWidgets(): Promise<void> {
    if (window.twttr?.widgets) {
        return Promise.resolve();
    }

    if (!widgetsLoadPromise) {
        widgetsLoadPromise = new Promise((resolve) => {
            const onReady = () => resolve();
            const existing = document.getElementById(WIDGETS_SCRIPT_ID);

            if (existing) {
                existing.addEventListener("load", onReady, {once: true});
                return;
            }

            const script = document.createElement("script");
            script.id = WIDGETS_SCRIPT_ID;
            script.src = WIDGETS_SCRIPT_SRC;
            script.async = true;
            script.charset = "utf-8";
            script.onload = onReady;
            document.body.appendChild(script);
        });
    }

    return widgetsLoadPromise;
}

export const XEmbed = ({html}: {html: string}) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const container = containerRef.current;

        if (!container) {
            return;
        }

        container.innerHTML = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");

        loadXWidgets().then(() => {
            window.twttr?.widgets?.load(container);
        });
    }, [html]);

    return <div ref={containerRef} css={wrapper} />;
};

const wrapper = css`
    display: flex;
    justify-content: center;
`;

declare global {
    interface Window {
        twttr?: {
            widgets?: {
                load: (element?: HTMLElement) => void;
            };
        };
    }
}
